
import { Observable } from 'rxjs';
import { Navigation } from '@kion/data-models';
import { map } from 'rxjs/operators';

export class NavBuilderService {

  constructor(public navigations: Observable<Navigation[]>) { }

  findTree$(uid: string): Observable<Navigation> {
    return this.navigations.pipe(
      map(
        (navigations: Navigation[]) => navigations.find(
          nav => this.searchTree(uid, nav)
        )
      )
    )
  }

  private searchTree(uid: string, navigation: Navigation): boolean {
    if (uid === navigation.link.targetUid) {
      return true
    }
    let found = false;
    if (navigation.children && navigation.children.length > 0) {
      found = navigation.children.some(
        child => {
           found = this.searchTree(uid, child);
          if (found) {
            return found
          }
        }
      )
    }
    return found;
  }

}
